<form [formGroup]="formFilter" cForm class="container-filter">
  <mat-form-field>
    <mat-label>Busqueda</mat-label>
    <input id="inputGeneral"
      (keyup.enter)="filtroGeneral($event)"
      matInput
      formControlName="generalFilter"
      placeholder="Busqueda "
    />
  </mat-form-field>
  <mat-form-field>
    <mat-label>Clave SII</mat-label>
    <mat-select (selectionChange)="changeSiiSelect($event)" formControlName="sii">      
      <mat-option value="yes">Enrolado</mat-option>
      <mat-option value="no">No enrolado</mat-option>
      <mat-option value="">Todos</mat-option>
    </mat-select>  
  </mat-form-field>
</form>